import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { ColorVariables } from 'src/theme/style-guide/_color-variables';

@UntilDestroy()
@Component({
  selector: 'sm-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['breadcrumb.component.scss'],
  standalone: false
})
export class BreadcrumbComponent implements OnInit {
  isBreadcrumbLoading: boolean;
  breadcrumbConfig: BreadcrumbConfig = {
    bgColor: ColorVariables.$blueGray,
    fontSize: '0.75rem',
    fontColor: ColorVariables.$grayFilled400,
    lastLinkColor: ColorVariables.$grayFilled600
  };

  constructor(private readonly router: Router,
              private readonly breadcrumbService: BreadcrumbService) {
  }

  async ngOnInit() {
    this.breadcrumbService.bgColor.pipe(untilDestroyed(this)).subscribe(x => {
      this.breadcrumbConfig['bgColor'] = x;
    });

    this.breadcrumbService.isLoading.pipe(untilDestroyed(this)).subscribe(x => {
      this.isBreadcrumbLoading = x;
    });

    this.router.events
        .pipe(untilDestroyed(this))
        .pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.breadcrumbService.isLoading.emit(true);
    });
  }
}

export class BreadcrumbConfig {
  bgColor?: string;
  fontSize?: string;
  fontColor?: string;
  lastLinkColor?: string;
}
